// extracted by mini-css-extract-plugin
export default {"root":"Aside_root__50NSP","collapse":"Aside_collapse__WI6oY","menuWrapper":"Aside_menuWrapper__FQ70+","menu":"Aside_menu__H00jl","activeLink":"Aside_activeLink__xS269"};